module.exports = __webpack_public_path__ + "static/img/modernWeb190.aeeeaf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/modernWeb19/modernWeb190.jpg
// module id = kUjJ
// module chunks = 1